import "./Menu.scss"
import { useNavigate } from 'react-router-dom';
export function Menu({ inline = false }) {
  const navigate = useNavigate();

  const goToLeadershipPage = () => {
    navigate('/our-leadership');
  };

  const goToLibrary = () => {
    window.open('https://www.youtube.com/@EBCBowlingGreenMedia/streams', '_blank');
  }


  const goToMainPage = () => {
    navigate('/');
  };

  const goToOurBeliefs = () => {
    navigate('/what-we-believe');
  };

  const goToContact = () => {
    navigate('/contact');
  };

  return (
    <div id="menu" className={inline ? 'inline' : ''}>
      <div className="menu-item" onClick={e => { goToMainPage() }}>Home</div>
      <div className="menu-item" onClick={e => { goToOurBeliefs() }}>What we believe</div>
      <div className="menu-item" onClick={e => { goToLeadershipPage() }}>Our leadership</div>
      <div className="menu-item" onClick={e => { goToLibrary() }}>Sermon library</div>
      <div className="menu-item" onClick={e => { goToContact() }}>Have a question for us?</div>
    </div>

  );
}